module.exports = __webpack_public_path__ + "img/HY2702-84.07b084c9.jpg";